export default __webpack_public_path__ + "static/media/fuelAsseticon.7f980873.svg";